import React, { Component } from 'react';
import { Grid, Button, Divider, Tab, Header, Icon, Modal } from 'semantic-ui-react';
import DropdownLib from '../DropdownLib';
import Route from './tabs/route-tab';
import LastProjectSurf from './tabs/cons-segment/last-project-surf';
import Base from './tabs/cons-segment/base';
import XSection from './tabs/cons-segment/xsection';
import SurfaceTreatment from './tabs/cons-segment/maintenance/surface-treatment';
import CrackSeal from './tabs/cons-segment/maintenance/crackseal';
import Patching from './tabs/cons-segment/maintenance/patching';
import Blade from './tabs/cons-segment/maintenance/blade';
import Regravel from './tabs/cons-segment/maintenance/regravel';
import Reshape from './tabs/cons-segment/maintenance/reshape';
import SpotRep from './tabs/cons-segment/maintenance/spotrep';
import DustControl from './tabs/cons-segment/maintenance/dust-control';
import Cpr from './tabs/cons-segment/maintenance/cpr';
import ReApplyAst from './tabs/cons-segment/maintenance/reapply-ast';
import Striping from './tabs/cons-segment/maintenance/striping';
import Condition from './tabs/cons-segment/forecasting/condition';
import Strength from './tabs/cons-segment/forecasting/strength';
import Traffic from './tabs/cons-segment/forecasting/traffic';
import Future from './tabs/cons-segment/forecasting/future';
import 'semantic-ui-css/semantic.min.css';
import '../index.css';

export default class ConstuctionSegment extends Component {

    // TODO create data model
    constructor(props) {
        super(props);
        this.maintenanceTypes = DropdownLib.getDropdowns().CS_LastProjectSurf.lpSurfOptions;
        this.compositeTypes = DropdownLib.getDropdowns().CS_LastProjectSurf.compTypeOptions;
        console.log(this.props)

        if (this.props.loadData) {
            console.log("loading....");
            //console.log(this.props.dataModel);
            //console.log(this.props.loadData);
            this.state = {
                ConstuctionSegmentModel: this.props.loadData
            };
            console.log(this.state)
        }
        else {
            // This is a super data model class, its main function is to collect data from all the children components.
            this.state = {
                lpSurfModalOpen: false,
                curValue: "1",
                ConstuctionSegmentModel: {

                    layer: 1,
                    layerName: 'ConstructionSegment',
                    layerId: -1,
                    agencyId: -1, //to be determined later

                    route: {
                        id: -1, //id is not set, will be setting it soon.
                        start: '0,0',
                        end: '0,0',
                        routeLength: 0.0,
                        isPolyLine: false,
                        waypoints: [],
                        routeLine: null,
                        hwyNum: "",
                        segDesc: ""

                    },

                    // Note actual default val moved up here. When read from the db, this will be replaced by db options.
                    lpModel: {
                        lastProjectType: 0,
                        lastProjectSurf: 0,

                        gravelType: 0,
                        gravelTreatment: 0,
                        bitType: 0,
                        concrType: 0,
                        astType: 0,
                        compType: 0,

                        lastProjectYear: "0",

                        lpDepth: 0,
                        totalDepth: 0,

                        lastProjectMile: "0",
                        planURL:"",
                        comment: "",

                        lastProjectYearEst: 0,
                        lpDepthEst: 0,
                        totalDepthEst: 0
                    },

                    bModel: {
                        topBaseType: 0,
                        topBaseDpt: 0,
                        topBaseYear: "0",
                        topBaseTrt: 0,

                        bottomBaseType: 0,
                        bottomBaseDpt: 0,
                        bottomBaseYear: "0",
                        bottomBaseTrt: 0,
                        fabric: 0,

                        subgradeStrength: 0,
                        subgradeStrengthType: 0,
                        lastSGImpYear: "0",
                        subgradeTrt: 0,

                        topBaseTypeEst: 0,
                        topBaseDptEst: 0,
                        topBaseYearEst: 0,
                        bottomBaseTypeEst: 0,
                        bottomBaseDptEst: 0,
                        bottomBaseYearEst: 0,
                        subgradeStrengthEst: 0,
                        lastSGImpYearEst: 0
                    },

                    xModel: {
                        laneWidth: 0,
                        numLanes: 2,
                        rtShoulderTotal: 0,
                        rtShoulderPaved: 0,

                        gradingYear: "0",
                        curbs: 0,
                        inslopeRatio: 0,
                        paveSloughWidth: 0,
                        sloughRatio: 0,

                        edgelineTrt: 0,
                        centerlineTrt: 0,

                        medianType: 0,
                        medianWidth: 0,
                        rightOfWay: 0,
                        sectionOwner: 0,

                        gradingYearEst: 0
                    },

                    // Outline of Maintenance Layer
                    maintenance: {
                        // Gravel LP Surface
                        blade: [],
                        regravel: [],
                        reshape: [],
                        spotRep: [],
                        dustControl: [],

                        // Bituminous LP Surface
                        surfacing: [],
                        crackSeal: [],
                        patching: [],
                        striping: [], // On all but Gravel LP Surface

                        // Concrete LP Surface
                        cpr: [],
                        crackSealConcrete: [],

                        // AST LP Surface
                        //** Same as Bituminous + 
                        reApplyAst: [],

                        // Composite LP Surface
                        // has none...

                    },
                    pavementcondition: {
                        RQI: 0,
                        RQIOver: 0,
                        SR: 0,
                        SROver: 0,
                        PQI: 0,
                        PQIOver: 0,
                        IRI: 0,
                        IRIOver: 0,
                        PCI: 0,
                        PCIOver: 0,
                        RUT: 0,
                        RUTOver: 0,
                        PavementCollectedDate: 0,
                        PavementCollectedDateOver: 0,
                        SN: 0,
                        GE: 0,
                        ResMod: 0,
                        PlannedProjType: 0,
                        PlannedProjTypeOver: 0,
                        PlannedYear: 0,
                        PlannedYearOver: 0,
                        AADT: 0,
                        AADTOver: 0,
                        TrafficYear: 0,
                        GrowthFactor: 0,
                        GrowthFactorOver: 0
                    }

                }
            };


        }


        this.consHistOptions = {
            Inventory: 1,
            Maintenance: 2,
            Forecasting: 3
        };
        
        this.setState({
            curValue: this.consHistOptions[this.props.prevPane]
        })
        this.startVal = this.consHistOptions[this.props.prevPane]
        //backgroundColor: '#2185d0', color: 'white'
        // these are the tabs.
        this.panes = {
            Inventory: [
                {
                    menuItem: 'Location', render: () =>
                        <Tab.Pane>
                            <Route clickFunctions={this.props.clickFunctions}
                                trackLocationChanged={this.props.isLocationChanged}
                                triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled}
                                routeModel={this.state.ConstuctionSegmentModel.route} layername={this.state.ConstuctionSegmentModel.layerName}
                            />
                        </Tab.Pane>
                },
                {
                    menuItem: 'Last Project Surface', render: () =>
                        <Tab.Pane>
                            <LastProjectSurf triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled}
                                csModel={this.state.ConstuctionSegmentModel} />
                        </Tab.Pane>
                },
                {
                    menuItem: 'Base', render: () =>
                        <Tab.Pane>
                            <Base triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled}
                                csModel={this.state.ConstuctionSegmentModel} />
                        </Tab.Pane>
                },
                {
                    menuItem: 'Cross Section', render: () =>
                        <Tab.Pane>
                            <XSection triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled}
                                agencyId={this.props.agencyId}
                                csModel={this.state.ConstuctionSegmentModel} />
                        </Tab.Pane>
                },
            ],

            Maintenance: {

                none: [],
                Gravel: [
                    {
                        menuItem: 'Blade', render: () =>
                            <Tab.Pane>
                                <Blade triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Regravel', render: () =>
                            <Tab.Pane>
                                <Regravel triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Reshape', render: () =>
                            <Tab.Pane>
                                <Reshape triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'SpotRep', render: () =>
                            <Tab.Pane>
                                <SpotRep triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'DustControl', render: () =>
                            <Tab.Pane>
                                <DustControl triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    }
                ],
                Bituminous: [
                    {
                        menuItem: 'Surface Treatement', render: () =>
                            <Tab.Pane>
                                <SurfaceTreatment triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Crack Seal', render: () =>
                            <Tab.Pane>
                                <CrackSeal triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Patching', render: () =>
                            <Tab.Pane>
                                <Patching triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Striping', render: () =>
                            <Tab.Pane>
                                <Striping triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    }
                ],
                // this is shared with Bituminous
                Concrete: [
                    {
                        menuItem: 'Cpr', render: () =>
                            <Tab.Pane>
                                <Cpr triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Crack Seal', render: () =>
                            <Tab.Pane>
                                <CrackSeal triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Striping', render: () =>
                            <Tab.Pane>
                                <Striping triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    }
                ],
                // this is shared with Bituminous
                AST: [
                    {
                        menuItem: 'Surface Treatement', render: () =>
                            <Tab.Pane>
                                <SurfaceTreatment triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Crack Seal', render: () =>
                            <Tab.Pane>
                                <CrackSeal triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Patching', render: () =>
                            <Tab.Pane>
                                <Patching triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'ReApplyAst', render: () =>
                            <Tab.Pane>
                                <ReApplyAst triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Striping', render: () =>
                            <Tab.Pane>
                                <Striping triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    }
                ],
                CompositeAOC: [
                    {
                        menuItem: 'Surface Treatement', render: () =>
                            <Tab.Pane>
                                <SurfaceTreatment triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Crack Seal', render: () =>
                            <Tab.Pane>
                                <CrackSeal triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Patching', render: () =>
                            <Tab.Pane>
                                <Patching triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Striping', render: () =>
                            <Tab.Pane>
                                <Striping triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    }
                ],
                CompositeCOA: [
                    {
                        menuItem: 'Cpr', render: () =>
                            <Tab.Pane>
                                <Cpr triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Crack Seal', render: () =>
                            <Tab.Pane>
                                <CrackSeal triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Striping', render: () =>
                            <Tab.Pane>
                                <Striping triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    csModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    }
                ]
            },

            Forecasting:
                [
                    {
                        menuItem: 'Condition', render: () =>
                            <Tab.Pane>
                                <Condition clickFunctions={this.props.clickFunctions}
                                    triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    conditionModel={this.state.ConstuctionSegmentModel}
                                    setToShow={this.props.setToShow} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Strength', render: () =>
                            <Tab.Pane>
                                <Strength clickFunctions={this.props.clickFunctions}
                                    triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    showSpinner={this.props.showSpinner}
                                    strengthModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Traffic', render: () =>
                            <Tab.Pane>
                                <Traffic clickFunctions={this.props.clickFunctions}
                                    triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    trafficModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    },
                    {
                        menuItem: 'Future', render: () =>
                            <Tab.Pane>
                                <Future clickFunctions={this.props.clickFunctions}
                                    triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    futureModel={this.state.ConstuctionSegmentModel} />
                            </Tab.Pane>
                    }
                ]
        };

        this.props.dataModel.splice(0, this.props.dataModel.length);
        this.props.dataModel.push(this.state.ConstuctionSegmentModel);
    }

    componentDidMount() {
        if (this.props.prevPane == "Maintenance") {
            this.setState({
                pane: this.panes[this.props.prevPane]["Bituminous"],
                inMaintenance: false
            });
        } else {
            this.setState({
                pane: this.panes[this.props.prevPane],
                inMaintenance: false
            });
        }
    }

    updateModel = (constructionSegment) => {
        this.SetState({ ConstuctionSegmentModel: constructionSegment })
    }

    updateLpSurfIndex(ix) {
        this.setState({ lpSurfIndex: ix });
    };

    renderGritLayerUI = () => {
        const lpSurfString = this.maintenanceTypes[this.state.ConstuctionSegmentModel.lpModel.lastProjectSurf].label;
        return (
            <div>
                {/* <Grid.Row>
                    <div className="pt-form-group pt-inline">
                        <label><b>Construction History</b></label>&nbsp;&nbsp;&nbsp;
                    </div>
                </Grid.Row> */}
                <Grid.Row>
                    <div class="btn-group">
                        <button id='inventoryBtn' style={(this.state.curValue == 1 || this.startVal == 1) ? { backgroundColor: '#2185d0', color: 'white', fontSize: "14px" } : { backgroundColor: '#e0e1e2', color: 'black', fontSize: "14px" }} value="1" onClick={this.onChangePane}>Inventory</button>
                        <button id='maintBtn' style={(this.state.curValue == 2 || this.startVal == 2) ? { backgroundColor: '#2185d0', color: 'white', fontSize: "14px" } : { backgroundColor: '#e0e1e2', color: 'black', fontSize: "14px" }} value="2" onClick={this.onChangePane}>Maintenance</button>
                        <button id='perfBtn' style={(this.state.curValue == 3 || this.startVal == 3) ? { backgroundColor: '#2185d0', color: 'white', fontSize: "14px" } : { backgroundColor: '#e0e1e2', color: 'black', fontSize: "14px" }} value="3" onClick={this.onChangePane}>Performance</button>
                    </div>
                </Grid.Row>
                {this.state.inMaintenance && (<Grid.Row><label>{lpSurfString}</label></Grid.Row>)}
                <Divider />
                <Grid.Row>
                    <Tab panes={this.state.pane} activeIndex={this.props.activeIndex} onTabChange={this.onTabChange} />
                </Grid.Row>

                {/* Modal for when Last Project Surface not selected. */}
                <Modal
                    open={this.state.lpSurfModalOpen}
                    onClose={() => { this.setState({ lpSurfModalOpen: false }); }}
                    basic
                    size='small'>
                    <Header icon='browser' content='Incomplete Route!' />
                    <Modal.Content>
                        <p>Please select a Last Project Surface type before adding maintenance records.</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => { this.setState({ lpSurfModalOpen: false }); }} inverted>
                            <Icon name='checkmark' />Ok
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }

    onTabChange = (e, data) => {
        console.log(data.activeIndex)
        this.props.updateActiveIndex(data.activeIndex);
    }

    handleLpSurfModalOpen = (val) => this.setState({ lpSurfModalOpen: val })

    onChangePane = (e) => {
        this.startVal = 0
        const { target } = e;
        const { value } = target;
        //let pane = this.panes.Inventory;
        // eslint-disable-next-line
        if (parseInt(value) === 3) {

            let lpSurfStringTemp = this.maintenanceTypes[this.state.ConstuctionSegmentModel.lpModel.lastProjectSurf].label;
            if (lpSurfStringTemp === "Not Selected") {
                // There must be a value selected
                this.handleLpSurfModalOpen(true);
                e.target.value = 1;
                return;
            } else {
                this.setState({ pane: this.panes.Forecasting, inMaintenance: false, curValue: 3 });
                this.props.deleteDisabled(false);
                this.props.setPreviousPane('Forecasting');
            }
        } // eslint-disable-next-line
        else if (parseInt(value) === 2) {

            let lpSurfStringTemp = this.maintenanceTypes[this.state.ConstuctionSegmentModel.lpModel.lastProjectSurf].label;
            if (lpSurfStringTemp === "Not Selected") {
                // There must be a value selected
                this.handleLpSurfModalOpen(true);
                e.target.value = 1;
                return;
            }
            else if (lpSurfStringTemp === "Composite") {
                var compString = this.compositeTypes[this.state.ConstuctionSegmentModel.lpModel.compType].label;
                if (compString === "Asphalt Over Concrete")
                    lpSurfStringTemp += "AOC";
                else if (compString === "Concrete Over Asphalt")
                    lpSurfStringTemp += "COA";

            }
            const lpSurfString = lpSurfStringTemp;

            //const lpSurfString = this.maintenanceTypes[this.state.ConstuctionSegmentModel.lpModel.lastProjectSurf].label;

            // if lp surf is bituminous
            this.setState({ pane: this.panes.Maintenance[lpSurfString], inMaintenance: true, curValue: 2 });
            this.props.deleteDisabled(true);
            this.props.setPreviousPane('Maintenance');
        } // eslint-disable-next-line
        else if (parseInt(value) === 1) {

            let lpSurfStringTemp = this.maintenanceTypes[this.state.ConstuctionSegmentModel.lpModel.lastProjectSurf].label;
            if (lpSurfStringTemp === "Not Selected") {
                // There must be a value selected
                this.handleLpSurfModalOpen(true);
                e.target.value = 1;
                return;
            }
            else {
                this.setState({ pane: this.panes.Inventory, inMaintenance: false, curValue: 1 });
                this.props.deleteDisabled(false);
                this.props.setPreviousPane('Inventory');
            }

        }

        this.onTabChange(null, { activeIndex: 0 });
        console.log("here 5")
        //console.log("pane changed " + value);
    }


    componentDidUpdate() {
        //console.log('it updated');
    }

    render() {
        return this.renderGritLayerUI();
    }
}


// WEBPACK FOOTER //
// ./src/layers/cons-segment.js